<template>
    <div class="flats-view-btns">
        <div class="btn-item  btn-wow-effect-hover" :class="{'active' : flatsListView == 'list'}" @click="changeListView('list')"> 
            <svgIcon name="list-view" class="icon-list"/>
        </div>
        <div class="btn-item  btn-wow-effect-hover" :class="{'active' : flatsListView == 'grid'}" @click="changeListView('grid')">
            <svgIcon name="grid-view" class="icon-grid"/>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue'
    export default {
        name: 'flats-view-btns',
        components: {
            svgIcon,
        },
        data () {
            return {
            }
        },
        computed: mapGetters({
            flatsListView: 'loadFlatsListView',
            // indexPage: 'loadIndexPage',
        }),
        methods: {
            changeListView(data) {
                this.$store.commit('changeFlatsListView', data)
            }
        },
        beforeCreate() {
        },
        created () {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/flats-page/flats-view-btns.scss';
    @import '@/styles/components/flats-page/respond/flats-view-btns-respond.scss';
    // @import '@/styles/components/commerce-page/respond/commerce-view-btns-respond.scss';
    // @import '@/styles/components/commerce-page/respond/commerce-view-btns-respond.scss';
</style>